export default "__VITE_ASSET__Cq5XY5Cf__"